<template>
  <v-container class="vpd-privacy-policy" fluid>
    <vpd-md-viewer
      :source="source"
      title="Panaszkezelési szabályzat"
    />
  </v-container>
</template>

<script>
import VpdMdViewer from "../components/vpd-md-viewer/vpd-md-viewer";
import Doc from "../assets/complaint-policy.md";

export default {
  name: "complaint-policy",
  components: {
    VpdMdViewer,
  },
  data() {
    return {
      source: Doc,
    };
  },
  methods: {},
};
</script>
